import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "overview-controls row align-items-end" }
const _hoisted_2 = {
  key: 0,
  class: "col-auto col-pagination"
}
const _hoisted_3 = { class: "col-auto col-page-size-picker" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = {
  for: "resultsPerPage",
  class: "form-label me-2 mb-3"
}
const _hoisted_6 = { class: "col col-buttons" }
const _hoisted_7 = { class: "d-flex justify-content-end align-items-end" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "mas fs-1 lh-1" }, "category", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "mas fs-1 lh-1" }, "csv", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "mas fs-1 lh-1" }, "list", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "mas fs-1 lh-1" }, "grid_view", -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasePagination = _resolveComponent("BasePagination")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_dp_form = _resolveComponent("dp-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasProducts && _ctx.productsOverview.paging_metadata)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_BasePagination, {
            "pagination-data": _ctx.productsOverview.paging_metadata,
            "n-pagination-items": 7,
            "show-page-items-count": "",
            class: "d-flex flex-column me-3",
            onChangePage: _ctx.onChangePageNumber
          }, null, 8, ["pagination-data", "onChangePage"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_dp_form, {
        as: "form",
        novalidate: "",
        class: "mb-n3"
      }, {
        default: _withCtx(({ errors }) => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('resultsPerPage')), 1),
            _createVNode(_component_InputSelect, {
              modelValue: _ctx.productsPaging.size,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.productsPaging.size) = $event)),
                _ctx.onChangePageSize
              ],
              options: _ctx.pageSizeOptions,
              name: "resultsPerPage",
              selectText: _ctx.$t('selectText'),
              "is-floating": false,
              rules: "required",
              errors: errors
            }, null, 8, ["modelValue", "options", "selectText", "errors", "onUpdate:modelValue"])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_ctx.hasCategoryExpectedToggle && _ctx.hasProducts)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn text-primary p-0",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toggleExpectCategory()), ["prevent"]))
            }, _hoisted_9))
          : _createCommentVNode("", true),
        (_ctx.isCsvDownloadSupported && _ctx.hasProducts)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn text-success p-0 me-3",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('downloadCsv')), ["prevent"]))
            }, _hoisted_11))
          : _createCommentVNode("", true),
        (_ctx.isLayoutToggleSupported && _ctx.productsPaging.layout === _ctx.PimProductsOverviewPageLayoutEnum.TILES)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "btn text-primary p-0",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.setLayout(_ctx.PimProductsOverviewPageLayoutEnum.LIST)), ["prevent"]))
            }, _hoisted_13))
          : _createCommentVNode("", true),
        (_ctx.isLayoutToggleSupported && _ctx.productsPaging.layout === _ctx.PimProductsOverviewPageLayoutEnum.LIST)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              class: "btn text-primary p-0",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.setLayout(_ctx.PimProductsOverviewPageLayoutEnum.TILES)), ["prevent"]))
            }, _hoisted_15))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}